// 1黑料网 —— 单页首页静态演示数据
// 仅供静态展示，不接入任何真实接口。

export const siteName = "1黑料网";

export interface NavItem {
  label: string;
  icon: string;
  active?: boolean;
}

export const navItems: NavItem[] = [
  { label: "首页", icon: "ri-home-4-line", active: true },
  { label: "最新瓜", icon: "ri-flashlight-line" },
  { label: "热议广场", icon: "ri-fire-line" },
  { label: "榜单专区", icon: "ri-bar-chart-2-line" },
  { label: "深度复盘", icon: "ri-file-search-line" },
  { label: "找地址", icon: "ri-map-pin-2-line" },
];

export interface Board {
  title: string;
  desc: string;
  icon: string;
  posts: string;
  chipClass: string;
}

export const boards: Board[] = [
  { title: "吃瓜现场", desc: "最新爆料一线速递，蹲一个前排", icon: "ri-coupon-3-line", posts: "12.4k 帖", chipClass: "bg-primary-100 text-primary-700" },
  { title: "红黑榜", desc: "造型言行去留，路人打分围观", icon: "ri-empathize-line", posts: "8.1k 帖", chipClass: "bg-secondary-100 text-secondary-800" },
  { title: "塌房预警", desc: "人设裂缝讨论区，理性吃瓜", icon: "ri-alarm-warning-line", posts: "6.7k 帖", chipClass: "bg-primary-100 text-primary-700" },
  { title: "澄清与实锤", desc: "正反观点对开，证据链复盘", icon: "ri-scales-3-line", posts: "9.3k 帖", chipClass: "bg-accent-100 text-accent-800" },
  { title: "瓜田杂谈", desc: "茶余饭后闲聊，观点自由碰撞", icon: "ri-chat-3-line", posts: "15.6k 帖", chipClass: "bg-secondary-100 text-secondary-800" },
  { title: "理性劝和", desc: "不站队不引战，给情绪降温", icon: "ri-heart-2-line", posts: "4.9k 帖", chipClass: "bg-accent-100 text-accent-800" },
  { title: "真相考据", desc: "时间线整理，碎片拼真相", icon: "ri-time-line", posts: "7.2k 帖", chipClass: "bg-primary-100 text-primary-700" },
  { title: "萌新指路", desc: "1黑料网入口直达答疑与导航", icon: "ri-compass-3-line", posts: "3.8k 帖", chipClass: "bg-secondary-100 text-secondary-800" },
];

export interface TrendingItem {
  rank: string;
  title: string;
  tag: string;
  heat: string;
  trend: string;
}

export const trendingHot: TrendingItem[] = [
  { rank: "01", title: "顶流演唱会票价争议刷屏，你站哪边？", tag: "热议", heat: "428w", trend: "up" },
  { rank: "02", title: "当红小花红毯造型翻车，网友评论区吵翻了", tag: "造型", heat: "361w", trend: "up" },
  { rank: "03", title: "新剧未播先吵，演技之争冲上热搜", tag: "剧集", heat: "297w", trend: "up" },
  { rank: "04", title: "老牌综艺被指剪辑带节奏，路人缘两极分化", tag: "综艺", heat: "218w", trend: "down" },
  { rank: "05", title: "爱豆营业频率被扒，粉丝与路人又开撕", tag: "话题", heat: "186w", trend: "up" },
  { rank: "06", title: "年度红黑榜开启投票，今年谁最拉好感", tag: "榜单", heat: "152w", trend: "up" },
];

export interface LatestCard {
  img: string;
  tag: string;
  tagClass: string;
  title: string;
  excerpt: string;
  area: string;
  author: string;
  time: string;
  comments: string;
  views: string;
  like: string;
  featured?: boolean;
  hotBadge?: boolean;
}

export const latestFeed: LatestCard[] = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20ivory%20editorial%20magazine%20collage%20about%20celebrity%20gossip%20discussion%2C%20a%20dramatic%20handheld%20magnifying%20glass%20over%20newspaper%20clippings%20and%20speech%20bubbles%2C%20burnt%20orange%20and%20deep%20red%20flat%20illustration%20with%20soft%20paper%20grain%20texture%2C%20long%20shadows%20and%20spotlight%20composition%2C%20premium%20tabloid%20layout%2C%20no%20text%2C%20no%20words&width=640&height=800&seq=hm-feed-01&orientation=portrait",
    tag: "实锤复盘", tagClass: "bg-primary-100 text-primary-700",
    title: "「造型翻车」名场面大盘点：是造型师的锅还是艺人审美？",
    excerpt: "红毯照流出后被全网玩梗，造型团队连夜发声明。评论区有人搬出历年对比图，也有人劝「别过度解读」。",
    area: "红黑榜", author: "理讨员老周", time: "12 分钟前",
    comments: "2.1k", views: "46w", like: "1.2k", featured: true, hotBadge: true,
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20ivory%20editorial%20flat%20illustration%20of%20two%20groups%20of%20people%20having%20a%20heated%20online%20debate%20across%20a%20table%2C%20scales%20of%20justice%20in%20the%20center%2C%20speech%20bubbles%20and%20dotted%20connections%2C%20burnt%20orange%20and%20deep%20red%20palette%20with%20pine%20green%20accents%2C%20soft%20paper%20grain%2C%20long%20shadows%2C%20premium%20magazine%20collage%20style%2C%20no%20text%2C%20no%20words&width=720&height=480&seq=hm-feed-02&orientation=landscape",
    tag: "观点对开", tagClass: "bg-accent-100 text-accent-800",
    title: "工作室声明 vs 网友实锤，这份时间线信息量有点大",
    excerpt: "事情发酵三天，双方各执一词。我们从公开时间线出发，帮你看清哪些是真瓜、哪些是脑补。",
    area: "澄清与实锤", author: "考据姬", time: "48 分钟前",
    comments: "986", views: "28w", like: "873",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20collage%20of%20a%20microphone%2C%20camera%20and%20theater%20mask%20floating%20over%20a%20stage%2C%20acting%20versus%20reality%20debate%20theme%2C%20flat%20illustration%20with%20deep%20red%20and%20amber%20tones%2C%20subtle%20paper%20texture%20and%20dramatic%20spotlight%2C%20premium%20magazine%20layout%2C%20no%20text%2C%20no%20words&width=640&height=420&seq=hm-feed-03&orientation=landscape",
    tag: "剧集热聊", tagClass: "bg-secondary-100 text-secondary-800",
    title: "新剧「滤镜感」太重被吐槽，收视和口碑为何撕裂？",
    excerpt: "一边是收视飘红，一边是豆瓣被一星刷屏。这届观众到底想要什么样的剧？",
    area: "吃瓜现场", author: "观剧小鹿", time: "1 小时前",
    comments: "1.5k", views: "35w", like: "1.0k",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20ivory%20editorial%20flat%20illustration%20of%20a%20cute%20bird%20chirping%20into%20a%20megaphone%20inside%20a%20gossip%20newsroom%2C%20newspaper%20rolls%20and%20coffee%20cups%20around%2C%20burnt%20orange%2C%20deep%20red%20and%20warm%20amber%20palette%2C%20soft%20paper%20grain%20texture%2C%20long%20soft%20shadows%2C%20premium%20tabloid%20collage%20style%2C%20no%20text%2C%20no%20words&width=640&height=800&seq=hm-feed-04&orientation=portrait",
    tag: "塌房预警", tagClass: "bg-primary-100 text-primary-700",
    title: "人设崩塌前通常有这几个信号，老吃瓜人经验谈",
    excerpt: "从「宠粉人设」到「真性情」，盘点这几年常见的翻车路径，以及路人为何越来越冷静。",
    area: "瓜田杂谈", author: "瓜田老农", time: "2 小时前",
    comments: "1.8k", views: "41w", like: "2.3k",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20ivory%20editorial%20collage%20of%20a%20calendar%20and%20clock%20with%20a%20timeline%20thread%20and%20pushpins%2C%20timeline%20investigation%20theme%2C%20flat%20illustration%20in%20deep%20red%20amber%20and%20pine%20green%2C%20subtle%20paper%20grain%20and%20long%20shadows%2C%20premium%20magazine%20layout%2C%20no%20text%2C%20no%20words&width=720&height=480&seq=hm-feed-05&orientation=landscape",
    tag: "真相考据", tagClass: "bg-accent-100 text-accent-800",
    title: "「疑似恋情」被扒全程：一张同框图是怎么被玩成连续剧的",
    excerpt: "同款、同城、同路线，网友把线索串成一条时间线。理性讨论：这些真的算实锤吗？",
    area: "真相考据", author: "显微镜同学", time: "3 小时前",
    comments: "2.6k", views: "53w", like: "1.7k",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20flat%20illustration%20of%20a%20row%20of%20stars%20on%20a%20trophy%20podium%20with%20gold%2C%20silver%20and%20red%20medals%2C%20red%20carpet%20awards%20vote%20theme%2C%20burnt%20orange%20and%20deep%20red%20palette%20with%20soft%20paper%20grain%20and%20long%20shadows%2C%20premium%20editorial%20collage%20style%2C%20no%20text%2C%20no%20words&width=640&height=420&seq=hm-feed-06&orientation=landscape",
    tag: "年度榜单", tagClass: "bg-secondary-100 text-secondary-800",
    title: "年度红黑榜投票通道开启：你的一票决定排位",
    excerpt: "热闹了一整年，谁最拉好感、谁最劝退？去榜单专区投出你的态度，评论区聊聊理由。",
    area: "榜单专区", author: "榜单君", time: "5 小时前",
    comments: "3.2k", views: "68w", like: "2.9k",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20ivory%20editorial%20collage%20of%20two%20hands%20holding%20a%20steaming%20teacup%20and%20snacking%20seeds%20at%20a%20casual%20chat%20table%2C%20people%20gossiping%20in%20soft%20silhouette%20background%2C%20flat%20illustration%20in%20amber%20deep%20red%20and%20warm%20brown%2C%20subtle%20paper%20grain%20and%20cozy%20spotlight%2C%20premium%20magazine%20layout%2C%20no%20text%2C%20no%20words&width=640&height=800&seq=hm-feed-07&orientation=portrait",
    tag: "杂谈", tagClass: "bg-secondary-100 text-secondary-800",
    title: "如今吃瓜为什么越来越「吵」？一个路人的朴素观察",
    excerpt: "信息越堆越多，真相却越来越远。聊一聊围观这件事本身，如何保持体面不下场撕。",
    area: "瓜田杂谈", author: "冷静吃瓜", time: "6 小时前",
    comments: "1.1k", views: "19w", like: "946",
  },
];

export interface PollSide {
  label: string;
  ratio: number;
  votes: string;
  barClass: string;
  textClass: string;
}

export interface SpecialTopic {
  img: string;
  tag: string;
  title: string;
  desc: string;
  totalVotes: string;
  sideA: PollSide;
  sideB: PollSide;
  comment: string;
}

export const specialTopics: SpecialTopic[] = [
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20ivory%20editorial%20flat%20illustration%20of%20a%20large%20debate%20stage%20with%20a%20gavel%20and%20speech%20bubbles%20on%20both%20sides%2C%20audience%20in%20silhouette%20below%2C%20deep%20red%20amber%20and%20pine%20green%20palette%2C%20soft%20paper%20grain%20and%20dramatic%20spotlight%2C%20premium%20magazine%20collage%2C%20no%20text%2C%20no%20words&width=720&height=520&seq=hm-special-01&orientation=landscape",
    tag: "投票定调",
    title: "年度「最值得理性复盘」的争议事件",
    desc: "把整年吵得最凶的几桩瓜摆上台面，你更认可哪种处理方式？不站队，只表达立场。",
    totalVotes: "32.6w 人参与",
    sideA: { label: "支持当事人正面回应", ratio: 61, votes: "19.9w", barClass: "bg-primary-500", textClass: "text-primary-700" },
    sideB: { label: "更相信网友实锤时间线", ratio: 39, votes: "12.7w", barClass: "bg-accent-500", textClass: "text-accent-700" },
    comment: "评论区吵了 4.2w 条，最有共鸣的留言被顶上热评。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20flat%20collage%20of%20a%20laptop%20showing%20a%20privacy%20shield%20and%20padlock%2C%20someone%20carefully%20reading%20small%20text%20clippings%2C%20respectful%20gossip%20boundary%20theme%2C%20amber%20deep%20red%20and%20soft%20green%20tones%2C%20subtle%20paper%20grain%20and%20long%20soft%20shadows%2C%20premium%20magazine%20collage%20style%2C%20no%20text%2C%20no%20words&width=720&height=520&seq=hm-special-02&orientation=landscape",
    tag: "边界讨论",
    title: "吃瓜该不该有「止步线」？公开与隐私的边界在哪",
    desc: "围观公开场合的表现可以，扒私人行程算不算越界？这是一场关于分寸的诚实讨论。",
    totalVotes: "18.9w 人参与",
    sideA: { label: "公众人物应接受讨论", ratio: 44, votes: "8.3w", barClass: "bg-primary-500", textClass: "text-primary-700" },
    sideB: { label: "隐私与生活该被尊重", ratio: 56, votes: "10.6w", barClass: "bg-accent-500", textClass: "text-accent-700" },
    comment: "高赞回答：「有趣不等于有边界，体面是最高级的瓜品。」",
  },
];

export interface HotComment {
  author: string;
  tone: string;
  toneClass: string;
  initials: string;
  avatarClass: string;
  text: string;
  agree: string;
  time: string;
}

export const hotComments: HotComment[] = [
  {
    author: "一口酥酥", tone: "支持理性复盘", toneClass: "bg-accent-100 text-accent-800", initials: "酥",
    avatarClass: "bg-accent-500",
    text: "别急着下结论，先把时间线和原视频都看完再发言，很多瓜翻过来看根本不是那回事。",
    agree: "8.7k", time: "今日 21:04",
  },
  {
    author: "吃瓜不加冰", tone: "站网友实锤", toneClass: "bg-primary-100 text-primary-700", initials: "冰",
    avatarClass: "bg-primary-500",
    text: "文字声明谁都写得出，敢不敢把关键证据直接甩出来？大家要的是回应不是通稿。",
    agree: "6.3k", time: "今日 20:51",
  },
  {
    author: "老瓜民张叔", tone: "劝和降温", toneClass: "bg-secondary-100 text-secondary-800", initials: "张",
    avatarClass: "bg-secondary-500",
    text: "年年吵，年年忘。跟风之前先想想：这个瓜的「主角」真的是你讨厌的样子吗？",
    agree: "4.9k", time: "今日 20:37",
  },
];

export interface MoreLink {
  label: string;
  desc: string;
  icon: string;
}

export const moreLinks: MoreLink[] = [
  { label: "1黑料网 导航入口合集", desc: "收藏本页，随时一键直达最新地址与入口", icon: "ri-bookmark-line" },
  { label: "往期热门复盘归档", desc: "翻翻那些吵过又平静下来的瓜", icon: "ri-archive-line" },
  { label: "发言规则与瓜品公约", desc: "理性讨论，不带节奏不引战", icon: "ri-list-check-2" },
  { label: "萌新答疑直达", desc: "怎么找 1黑料网首页入口，常见问题都在这", icon: "ri-question-answer-line" },
];

export interface FooterCol {
  title: string;
  links: string[];
}

export const footerCols: FooterCol[] = [
  { title: "站点导览", links: ["首页直达", "最新瓜", "热议广场", "榜单专区", "深度复盘"] },
  { title: "板块分区", links: ["吃瓜现场", "红黑榜", "澄清与实锤", "瓜田杂谈", "真相考据"] },
  { title: "帮助与规则", links: ["找 1黑料网 入口", "最新地址更新", "瓜品公约", "理性讨论倡议", "联系反馈"] },
  { title: "常被问到", links: ["1黑料网 导航怎么用", "如何直达首页", "地址为什么更新", "怎么加入讨论", "提交爆料线索"] },
];